// removed by extract-text-webpack-plugin
module.exports = {"link-with-icon":"EmptyCart__link-with-icon","linkWithIcon":"EmptyCart__link-with-icon"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/EmptyCart/EmptyCart.scss
// module id = 2342
// module chunks = 8